<template>
  <div>
    <div
      v-for="(permission, index) in permissions"
      :key="index"
      class="mt-2 mb-2"
    >
      <ChildPermission :permission="permission" />
    </div>
  </div>
</template>

<script>
import ChildPermission from './ChildPermission';
export default {
  name: 'ChildrenPermissionList',
  components: {
    ChildPermission,
  },
  data() {
    return {};
  },

  methods: {},
  props: {
    permissions: {
      required: true,
      type: Object,
    },
  },
};
</script>
